module.exports = __webpack_public_path__ + "img/trash-can-outline.360c382e.svg";